import { render, staticRenderFns } from "./miniOrders.vue?vue&type=template&id=72ebd5f9&"
import script from "./miniOrders.vue?vue&type=script&lang=js&"
export * from "./miniOrders.vue?vue&type=script&lang=js&"
import style0 from "./miniOrders.vue?vue&type=style&index=0&id=72ebd5f9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports